import { render, staticRenderFns } from "./workflow.vue?vue&type=template&id=3d3465c4&scoped=true&"
import script from "./workflow.vue?vue&type=script&lang=js&"
export * from "./workflow.vue?vue&type=script&lang=js&"
import style0 from "./workflow.vue?vue&type=style&index=0&id=3d3465c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3465c4",
  null
  
)

export default component.exports